<template>
  <div id="marathonLiveMonitoring">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="liveMonitor_list">
      <div class="liveMonitor_item" v-for="item in videoArr" :key="item.id">
        <div class="video_item">
          <videoAliplayerV2 ref="VueAliplayerV2" :options="item.options" />
        </div>
        <div class="liveMonitor_bottom" v-text="item.videoName"></div>
      </div>
    </div>
    <div class="pagination_row">
      <MixtmtPagination
        @CurrentChange="handleCurrentChange"
        @SizeChange="handleSizeChange"
        :pageSizes="pageSizes"
        :pnum="pnum"
        :psize="psize"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import videoAliplayerV2 from '@components/base/video_aliplayer_v2.vue'
import MixtmtPagination from '@components/base/mixtmt_pagination.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import {
  https_marathon_stageteammenu,
  https_marathon_liveMonitoringList,
} from '@api/platfrom_marathon_api'
export default {
  name: 'marathonLiveMonitoring',
  components: { videoAliplayerV2, MixtmtPagination, marathon_select_opt },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      currStageMarathon: '',
      marathonTypeArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'marathonType',
            title: '赛事类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'marathonTypeArr',
          },
        ],
        selectOpt_list: [],
      },
      videoArr: [],
      pnum: 1,
      psize: 6,
      pageSizes: [6, 12, 18],
      total: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await this.getstageMarathon()
      this.computedSelectOpt(this.selectOptData.configArr)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    handleSizeChange(val) {
      console.debug(`每页 ${val} 条`)
      this.psize = val
      this.pnum = 1
      this.getList()
    },
    handleCurrentChange(val) {
      console.debug(`当前页: ${val}`)
      this.pnum = val
      this.getList()
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[0][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[0][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'marathonType') {
            this.currStageMarathon = valPathArr[1]
          }
          this.getList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getstageMarathon() {
      await https_marathon_stageteammenu(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.marathonTypeArr = res.data ? res.data : []
            this.currStageMarathon = res.data[0] ? res.data[0].value : ''
            this.getList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getList() {
      await https_marathon_liveMonitoringList(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        code: this.currStageMarathon,
        page: this.pnum,
        pageSize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.videoArr = res.data.datas
              ? res.data.datas.map((item) => {
                  return {
                    id: item.streamId,
                    options: {
                      source: item.streamUrl,
                      isLive: true,
                    },
                    videoName: item.streamName,
                  }
                })
              : []
            this.total = res.data.total
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#marathonLiveMonitoring {
  width: 100%;
  padding: 2.778vw 0;
  .select_area {
    position: relative;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .liveMonitor_list {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    align-content: flex-start;
    .liveMonitor_item {
      margin: 0 1.74vw 1.743vw 0;
      width: 25.69vw;
      height: 17.98vw;
      border: 1px solid var(--mixtmt_greyColor4);
      border-radius: 0.556vw;
      overflow: hidden;
      &:nth-child(3n) {
        margin: 0 0 1.743vw 0;
      }
      .video_item {
        position: relative;
        width: 100%;
        height: 14.51vw;
      }
      .liveMonitor_bottom {
        padding: 0 1.388vw;
        width: 100%;
        height: 3.47vw;
        line-height: 3.47vw;
        background-color: var(--mixtmt_mainColor6);
        font-size: 1.11vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .pagination_row {
    width: 100%;
    text-align: right;
  }
}
</style>
